module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_8011.44be0c91.png";